import Hero from '../components/Hero';
import Probleme from '../components/Probleme';
import Solution from '../components/Solution';
import ClientsCibles from '../components/ClientsCibles';
import Briques from '../components/Briques';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import NavigationSticky from '../components/NavigationSticky';

const HomePage = () => {
  return (
    <>
      <SEO
        title="Tunisie Parking - Parking intelligent Tunisie | Digitalisation Horizon 2030"
        description="Tunisie Parking - La solution intelligente qui digitalise le stationnement en Tunisie. Gérez vos parkings, réservez votre place et payez facilement. Projet nextTunisia - Digitalisation Horizon 2030."
        keywords="parking tunisie, stationnement intelligent, parking digital, gestion parking, réservation parking, paiement parking, parking mobile, parking en ligne, tunisie parking, nextTunisia, digitalisation tunisie"
        url="https://parking.tn/"
      />
      <NavigationSticky />
      <div className="min-h-screen">
        <Hero />
        <Probleme />
        <Solution />
        <ClientsCibles />
        <Briques />
        <Footer />
      </div>
    </>
  );
};

export default HomePage;

